import { TextField, useTheme } from "@mui/material";
import PropTypes from "prop-types";

export const LabelTextField = (props) => {
  const { label, disabled, textInput, onTextChange, error, helperText } = props;

  const theme = useTheme();

  return (
    <TextField
      fullWidth
      disabled={disabled}
      label={label}
      value={textInput}
      onChange={onTextChange}
      variant="outlined"
      error={error}
      helperText={helperText}
      inputProps={{
        sx: {
          fontSize: 16,
          fontWeight: 400,
          color: theme.palette.primary.main,
        },
      }}
      sx={{
        "& .MuiOutlinedInput-root": {
          borderRadius: 2,
          "& fieldset": {
            borderColor: theme.palette.secondary.main,
          },
        },
      }}
    />
  );
};

LabelTextField.propTypes = {
  label: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  textInput: PropTypes.string,
  onTextChange: PropTypes.func.isRequired,
  error: PropTypes.bool,
  helperText: PropTypes.string,
};

LabelTextField.defaultProps = {
  disabled: false,
};
